<template>
  <b-tab title="Genre">
    <div class="form-row">
      <div class="col-sm-4">
        <b-form-select
          v-model="genre1"
          class="my-4"
          size="sm"
          :options="genre1Options"
        />
      </div>
      <div class="col-sm-4">
        <b-form-select
          v-model="genre2"
          class="my-4"
          size="sm"
          :options="genre2Options"
          :disabled="!genre2Options.length"
        />
      </div>
      <div class="col-sm-4">
        <b-form-select
          v-model="genre3"
          class="my-4"
          size="sm"
          :options="genre3Options"
          :disabled="!genre3Options.length"
        />
      </div>
      <div class="col-sm-12">
        <b-button
          class="my-4"
          variant="success"
          size="sm"
          :disabled="!genre1"
          @click="saveConfig"
        >
          Add        
        </b-button>

        <b-button
          v-if="configArray.length > 1"
          class="my-4 ml-2"
          variant="danger"
          size="sm"
          @click="deleteAllSelections"
        >
          Ta bort alla
        </b-button>
      </div>
      <b-list-group class="col-sm-12">
        <b-list-group-item
          v-for="(item, index) in configArray"
          :key="index"
        >
          <span>{{ item.genreString }}</span>
          <b-button
            class="ml-2 float-right"
            variant="danger"
            size="sm"
            @click="deleteSelection(index)"
          >
            Ta bort
          </b-button>
        </b-list-group-item>
      </b-list-group>
    </div>
  </b-tab>
</template>

<script>
export default {
  name: "GenrePickerGenre",
  props: ["genresArray", "configArray"],
  data() {
    return {
      genre1: null,
      genre2: null,
      genre3: null,
      genre1Options: [],
      genre2Options: [],
      genre3Options: []
    };
  },
  computed: {
    configs() {
      return [];
    }
  },
  watch: {
    genre1() {
      return this.getGenre2();
    },
    genre2() {
      return this.getGenre3();
    }
  },
  mounted() {
    this.getGenre1();
  },
  methods: {
    saveConfig() {
      if (!this.genre1) return;

      let config = { genre1: this.genre1 };
      if (this.genre2) config.genre2 = this.genre2;
      if (this.genre3) config.genre3 = this.genre3;

      config.genreString = this.genre1;
      if (this.genre2) {
        config.genreString += "; ";
        config.genreString += this.genre2;
      }

      if (this.genre3) {
        config.genreString += "; ";
        config.genreString += this.genre3;
      }

      if (this.configArray.some(e => e.genreString === config.genreString)) {
        this.$bvToast.toast("Genren finns redan", {
          title: "Warning",
          variant: "warning",
          solid: true,
          autoHideDelay: 3000
        });
      } else {
        this.configArray.push(config);
      }
    },
    deleteSelection(index) {
      this.configArray.splice(index, 1);
    },
    deleteAllSelections() {
      this.configArray.splice(0, this.configArray.length);
    },
    async getGenre1() {
      this.genre2Options = [];
      this.genre3Options = [];

      const genre1Array = this.genresArray
        .map(({ genre1 }) => genre1)
        .filter((value, index, self) => self.indexOf(value) === index);
      const genresArray = genre1Array.map(obj => {
        return {
          value: obj,
          text: obj
        };
      });
      return this.genre1Options = [
        { value: null, text: "Select an option" },
        ...genresArray
      ];
    },
    async getGenre2() {
      this.genre2 = null;
      this.genre3 = null;
      this.genre3Options = [];

      const genre2Array = this.genresArray
        .filter(gen => gen.genre1 === this.genre1)
        .map(({ genre2 }) => genre2)
        .filter((value, index, self) => self.indexOf(value) === index);

      const genresArray = genre2Array.map(obj => {
        return {
          value: obj,
          text: obj
        };
      });

      return this.genre2Options = [
      { 
        value: null, text: "Select an option" },
        ...genresArray,
      ];
    },
    async getGenre3() {
      this.genre3 = null;

      const genre3Array = this.genresArray
        .filter(gen => gen.genre2 === this.genre2)
        .map(({ genre3 }) => genre3)
        .filter((value, index, self) => self.indexOf(value) === index);

      const genresArray = genre3Array.map(obj => {
        return {
          value: obj,
          text: obj
        };
      });

      return this.genre3Options = [
        { value: null, text: "Select an option" },
        ...genresArray,
      ];
    }
  }
};
</script>
